/// <reference path="lib/solclient-full.js" />
/*global console, solace, escape */
/*jshint browser:true */

(function (ns) {
  "use strict";

  ns.priv = ns.priv || {};

  // Turn debug to turn in order to log events.
  var DEBUG = false;

  // Not all browsers define the console, so we only log when it's available.
  var logger = (function () {
      function fwd(fname, args) {
          if (typeof console === "object" && typeof console[fname] === "function" && DEBUG) {
              console[fname].apply(console, args);
          }
      }
      return {
          log: function () { fwd('log', arguments); },
          debug: function () { fwd('debug', arguments); },
          warn: function () { fwd('warn', arguments); },
          error: function () { fwd('error', arguments); },
          info: function () { fwd('info', arguments); }
      };
  }());

  // Default settings (can be overridden in constructor).
  var ClientWrapperDefaults = {
      connectRetryCount: 0,
      connectRetryInterval: 1000,
      subscriptionRetryCount: 0,
      subscriptionRetryInterval: 1000,
      subscriptionTimeout: 5000
  };

  /// <var>Enumeration of indication types</var>
  ns.IndicationType = {
      /// <field name="SESSION_UP">Session is up.</field>
      SESSION_UP: "SESSION_UP",
      /// <field name="SESSION_DOWN_RETRYING">Session is down, but wrapper will retry.</field>
      SESSION_DOWN_RETRYING: "SESSION_DOWN_RETRYING",
      /// <field name="SESSION_DOWN">Session is down, there will be no further attempts.</field>
      SESSION_DOWN: "SESSION_DOWN",
      /// <field name="SUBSCRIPTION_OK">Subscription operation completed successfully.</field>
      SUBSCRIPTION_OK: "SUBSCRIPTION_OK",
      /// <field name="SUBSCRIPTION_FAILED">Subscription operation did not complete and all retries have been exhausted.</field>
      SUBSCRIPTION_FAILED: "SUBSCRIPTION_FAILED",
      /// <field name="DISCARD_INDICATION">Indicates that one or more messages destined to this client are known to have been discarded at the appliance's egress.</field>
      DISCARD_INDICATION: "DISCARD_INDICATION",
      /// <field name="SESSION_UP_WITH_SUBSCRIPTIONS">The connection was recovered, also indicates that all subscriptions were re-established successfully.</field>
      SESSION_UP_WITH_SUBSCRIPTIONS: "SESSION_UP_WITH_SUBSCRIPTIONS",
      /// <field name="UNSUBSCRIBE_OK">Subscription operation (remove) completed successfully.</field>
      UNSUBSCRIBE_OK: "UNSUBSCRIBE_OK",
      /// <field name="UNSUBSCRIBE_FAILED">Subscription operation (remove) did not complete and all retries have been exhausted.</field>
      UNSUBSCRIBE_FAILED: "UNSUBSCRIBE_FAILED"
  };

  ns.Statistics = {
      SESSION_UP_COUNT: "SESSION_UP_COUNT",
      SESSION_CONNECT_ATTEMPTS_COUNT: "SESSION_CONNECT_ATTEMPTS_COUNT",
      SESSION_CONNECT_FAIL_COUNT: "SESSION_CONNECT_FAIL_COUNT",
      SUBSCRIPTION_OK_COUNT: "SUBSCRIPTION_OK_COUNT",
      SUBSCRIPTION_FAILED_COUNT: "SUBSCRIPTION_FAILED_COUNT",
      UNSUBSCRIBE_OK_COUNT: "UNSUBSCRIBE_OK_COUNT",
      UNSUBSCRIBE_FAILED_COUNT: "UNSUBSCRIBE_FAILED_COUNT",
      DISCARD_INDICATION_COUNT: "DISCARD_INDICATION_COUNT",
      MESSAGES_RECEIVED_COUNT: "MESSAGES_RECEIVED_COUNT"
  };

  var ResponseCodes = {
      // Indicates successful result of request.
      OK_200: "OK_200",
      // Indicates UNsuccessful request, non-retryable.
      FAIL_TERMINAL_40x: "FAIL_TERMINAL_40x",
      // Indicates UNsuccessful request, which could be retryable.
      FAIL_RETRYABLE_50x: "FAIL_RETRYABLE_50x"
  };
  var SRC_REAPPLY = "reapply", SRC_USER = "user";

  function AsyncIndication(type, message, extra) {
      /// <summary>
      /// Private object: wraps an async ClientWrapper indication.
      /// Clients must know what fields to expect: indicationType and message.
      /// </summary>
      this.indicationType = type;
      this.message = message;
      for (var n in extra) {
          this[n] = extra[n]; // copy extra fields
      }
  }

  function MessageIndication(solMessage) {
      /// <summary>
      /// Wraps a message indication.
      /// </summary>
      /// <param name="solMessage">solace message object</param>
      this.getMessage = function () {
          /// <summary>
          /// Gets the raw Solace API message.
          /// </summary>
          /// <returns type="object">solace.Message</returns>
          return solMessage;
      };

      this.getBodyJson = function () {
          /// <summary>
          /// Parse the JSON body out of the solace message and return it as an object.
          /// </summary>
          /// <returns type="object">An object with the parsed body.</returns>

          var binAttachment = solMessage.getBinaryAttachment();
          binAttachment = utf8BinaryToString(binAttachment);
          return JSON.parse(binAttachment);
      };

      this.getTopic = function () {
          /// <summary>
          /// Gets the topic string the message was sent to.
          /// </summary>
          /// <returns type="string">string</returns>
          return solMessage.getDestination().getName();
      };
  }
  ns.MessageIndication = MessageIndication;

  function ConnectState() {
      /// <summary>Object to track state while reconnecting / reestablishing subscriptions.</summary>

      // connect attempt counter: int
      this.attempt = 1;

      this.resetCount = function () {
          /// <summary>Reset connection attempts</summary>
          this.attempt = 1;
      };

      this.increment = function () {
          /// <summary>Incr connection attempts</summary>
          this.attempt += 1;
      };

      var retryWaiting = {};

      this.getWaitingSize = function () {
          return countOwnProperties(retryWaiting);
      };

      this.addRetriesWaiting = function (reapplyRequest) {
          retryWaiting[reapplyRequest.uniqueId] = reapplyRequest;
      };

      this.clearRetriesWaiting = function () {
          retryWaiting = {};
      };

      // Callback on successful re-establish operation, returns true if we're all done!
      this.ok = function (resp) {
          delete retryWaiting[resp.uniqueId];
          return (this.getWaitingSize() === 0);
      };

      // Callback on failed re-establish operation.
      this.fail = function (resp) {
          delete retryWaiting[resp.uniqueId];
      };
  }

  /*
   String formatter: Takes as input "hello {0}!", 'world' and produces "hellow world!".
   That is, uses numeric placeholders {0}, {1}, {2}, ... to replace with other arguments.
   */
  function strfmt() {
      var str = arguments[0];
      for (var i = 1; i < arguments.length; i++) {
          // replace {i} with i-th argument
          str = str.replace(
              new RegExp("\\{" + (i - 1) + "\\}"),
              "" + arguments[i]
          );
      }
      return str;
  }

  /*
   Count property keys in an object (like a dictionary.keys().length).
   */
  function countOwnProperties(obj) {
      var i = 0;
      for (var n in obj) {
          if (obj.hasOwnProperty(n))
              i++;
      }
      return i;
  }

  /*
   Random 16-digit hex string for uniquely identifying request IDs.
   */
  function randId() {
      var str = [];
      for (var i = 0; i < 16; i++) {
          var r = Math.floor(Math.random() * 16);
          str.push(r.toString(16));
      }
      return str.join("");
  }

  /*
   All information related to a single request.
   */
  function RequestWrapper(serviceTopic, reqDict, correlationKey, typeOptions) {
      // messaging API correlation key
      this.uniqueId = randId();
      // topic to address requests
      this.serviceTopic = serviceTopic;
      // request contents
      this.reqDict = reqDict;
      // user correlation key, to pass back to app
      this.correlationKey = correlationKey;
      // Request type options: { okEvent=eventtype, failEvent=eventtype, source="reapply"||"user" }
      this.typeOptions = typeOptions;
      // Track number of attempts for a request
      this.attempt = 1;

      this.isRetryAllowed = function (maxRetries) {
          return (this.attempt <= maxRetries);
      };

      this.toString = function () {
          return strfmt("RequestWrapper({0} {1} attempts)", JSON.stringify(this.reqDict), this.attempt);
      };
  }
  ns.priv.RequestWrapper = RequestWrapper; // for unit test access

  /*
   HACK: convert solace binary attachment to a string.
   */
  function utf8BinaryToString(binarydata) {
      // fixme escape is deprecated, how else do we read Solace API binary strings?
      return decodeURIComponent(escape(binarydata));
  }

  /*
   Format and Parse between RequestWrapper and solace messages.
   */
  function RequestFormatter() {
      function sdtString(str) {
          return solace.SDTField.create(solace.SDTFieldType.STRING, str);
      }

      function populateOperationHeader(msg) {
          var hdrMap = new solace.SDTMapContainer();
          hdrMap.addField("Version", sdtString("1"));
          hdrMap.addField("Encoding", sdtString("JSON"));
          hdrMap.addField("Datatype", sdtString("Operation"));
          msg.setUserPropertyMap(hdrMap);
      }

      this.asRequestMessage = function (reqWrapper) {
          var msg = solace.SolclientFactory.createMessage();
          var jsonbody = JSON.stringify(reqWrapper.reqDict);
          msg.setDestination(solace.SolclientFactory.createTopic(reqWrapper.serviceTopic));
          msg.setDeliverToOne(true);
          populateOperationHeader(msg);
          msg.setBinaryAttachment(jsonbody);
          return msg;
      };

      this.parseResponseMessage = function (msg) {
          var hdrMap = msg.getUserPropertyMap();
          if (!(hdrMap &&
              hdrMap.getField("Version") &&
              hdrMap.getField("Version").getValue() === "1")) {
              throw new Error("Response parse error: could not find header with Version=1.");
          }
          if (!(hdrMap &&
              hdrMap.getField("Encoding") &&
              hdrMap.getField("Encoding").getValue() === "JSON")) {
              throw new Error("Response parse error: unsupported encoding");
          }

          var jsonbody = msg.getBinaryAttachment() || "";
          jsonbody = utf8BinaryToString(jsonbody);
          return JSON.parse(jsonbody);
      };
  }
  ns.priv.RequestFormatter = RequestFormatter; // for unit test access

  /*
   a cache of all desired subscriptions, indexed by subscription topic
   */
  function SubscriptionCache() {
      var cache = {};
      var pending = {};

      this.startAddSubscription = function (requestObj) {
          var subscription = requestObj.reqDict.SubscriptionTopic;
          pending[subscription] = requestObj;
      };

      this.processAddOk = function (requestObj) {
          var subscription = requestObj.reqDict.SubscriptionTopic;
          if (typeof pending[subscription] !== "undefined") {
              delete pending[subscription];
              cache[subscription] = requestObj;
          }
      };

      this.removeSubscription = function (requestObj) {
          var subscription = requestObj.reqDict.SubscriptionTopic;
          delete cache[subscription];
          delete pending[subscription];
      };

      this.getSubscriptionSet = function () {
          var resp = [];
          for (var n in cache) {
              resp.push(cache[n]);
          }
          return resp;
      };

  }
  ns.priv.SubscriptionCache = SubscriptionCache;


  function ClientWrapper(props) {
      /// <summary>
      /// Constructor for the ClientWrapper API, main entry point.
      ///
      /// <para>The props object is a map satisfying:</para>
      /// <para>{</para>
      /// <para>    solaceSessionProperties: a solace.SessionProperties instance</para>
      /// <para>    eventCallback: a function(event, ClientWrapper) to callback for wrapper events</para>
      /// <para>    messageCallback: a function(message, ClientWrapper) to callback for message delivery</para>
      /// <para>    [connectRetryCount]: [optional] a number, times to attempt connection establishment. Default 0.</para>
      /// <para>    [connectRetryInterval]: [optional] Delay between retry attempts (ms). Default 1000.</para>
      /// <para>    [subscriptionRetryCount]: [optional] Number of times to attempt retry on a subscription operation failure (timeout or error response). Default 0.</para>
      /// <para>    [subscriptionRetryInterval]: [optional] Delay between retry attempts (ms). Default 1000.</para>
      /// <para>    [subscriptionTimeout]: [optional] Delay before a subscription attempt times out and is considered failed. Default 5000.</para>
      /// <para>}</para>
      ///
      /// </summary>
      /// <param name="props" type="object">Configuration properties</param>

      // overlay given properties and defaults
      var myCW = this;
      for (var n in ClientWrapperDefaults) {
          if (!props.hasOwnProperty(n)) { props[n] = ClientWrapperDefaults[n]; }
      }
      this.props = props;

      (function validateProps() {
          function valPresent(bag, property) {
              if (typeof bag[property] === "undefined") {
                  throw new Error("Expected property: " + property);
              }
          }
          function valPresentType(bag, property, expectType) {
              var mytype = typeof bag[property];
              if (mytype !== expectType) {
                  throw new Error("Expected property " + property + " of type " + expectType + ", got " + mytype);
              }
          }
          valPresent(props, "solaceSessionProperties");
          valPresentType(props, "eventCallback", "function");
          valPresentType(props, "messageCallback", "function");
          valPresentType(props, "connectRetryCount", "number");
          valPresentType(props, "connectRetryInterval", "number");
          valPresentType(props, "subscriptionRetryCount", "number");
          valPresentType(props, "subscriptionRetryInterval", "number");
          valPresentType(props, "subscriptionTimeout", "number");
      }());

      // Set minimum intervals
      this.props.connectRetryInterval = Math.max(this.props.connectRetryInterval, 100);
      this.props.subscriptionRetryInterval = Math.max(this.props.subscriptionRetryInterval, 100);

      // Set minimum buffer size for large requests
      this.props.solaceSessionProperties.sendBufferMaxSize = Math.max(
          this.props.solaceSessionProperties.sendBufferMaxSize,
          500 * 1024);

      // Init our message / event CB
      this.messageCallback = this.props.messageCallback;
      this.eventCallback = this.props.eventCallback;
      // A list of in-progress work items (requests) indexed by their generatedCorrelationId
      var workQueue = {};
      // Cache of subscriptions added successfully
      this.subscriptionCache = new SubscriptionCache();
      var subscriptionCache = this.subscriptionCache;
      // Desired state of the session (up: 1, or down: 0), determines whether to attempt reconnects.
      this.desiredState = 0;
      this.stats = {};
      for (var stat in ns.Statistics) {
          this.stats[ns.Statistics[stat]] = 0;
      }

      var reconnectStatus = new ConnectState();

      // Instance methods
      this._incrStat = function (stat, amt) {
          amt = amt || 1;
          myCW.stats[stat] += amt;
      };

      this._getClientId = function () {
          return this.getSessionProperties().clientName;
      };

      // Safely dispatch an async indication to the application.
      function dispatchEvent(evt) {
          try {
              if (evt instanceof AsyncIndication) {
                  myCW.eventCallback(evt, myCW);
              } else if (evt instanceof MessageIndication) {
                  myCW.messageCallback(evt, myCW);
              }
          } catch (err) {
              logger.warn("Error caught while dispatching to application callback.", err, err.stack);
          }
      }

      // Recover after connecting
      function startRecovery() {
          var tmp = [];
          for (var n in workQueue) {
              // clear all API-sourced re-apply requests
              if (workQueue.hasOwnProperty(n) && workQueue[n].typeOptions.source !== SRC_REAPPLY) {
                  // save for retry if it's user-generated task
                  tmp.push(workQueue[n]);
              }
          }
          logger.debug(strfmt("dbg>recov: {0} user work items to be retried, workQueue({1})", tmp.length, countOwnProperties(workQueue)));
          workQueue = {}; // clear work tracker
          var i = 0;
          for (i = 0; i < tmp.length; i++) {
              performRetry(tmp[i]);
          }
          var toReapply = subscriptionCache.getSubscriptionSet();
          logger.debug(strfmt("dbg>recov: {0} cached subscriptions to reapply", toReapply.length));
          reconnectStatus.clearRetriesWaiting();
          for (i = 0; i < toReapply.length; i++) {
              var req = new RequestWrapper(
                  toReapply[i].serviceTopic,
                  toReapply[i].reqDict,
                  toReapply[i].correlationKey,
                  { okEvent: ns.IndicationType.SUBSCRIPTION_OK, failEvent: ns.IndicationType.SUBSCRIPTION_FAILED, source: SRC_REAPPLY });
              reconnectStatus.addRetriesWaiting(req);
              myCW._submitRequest(req);
          }
      }

      // session event handlers for Solace API session
      function soleventcb(rxsession, sessionevent) {
          logger.debug("dbg>soleventcb> " + sessionevent);
          switch (sessionevent.sessionEventCode) {
              case solace.SessionEventCode.UP_NOTICE:
                  myCW._incrStat(ns.Statistics.SESSION_UP_COUNT);
                  reconnectStatus.resetCount();
                  startRecovery();
                  dispatchEvent(new AsyncIndication(ns.IndicationType.SESSION_UP, sessionevent.infoStr, null));
                  if (reconnectStatus.getWaitingSize() === 0) {
                      // nothing to recover: fully up
                      dispatchEvent(new AsyncIndication(ns.IndicationType.SESSION_UP_WITH_SUBSCRIPTIONS, sessionevent.infoStr, null));
                  }
                  break;
              case solace.SessionEventCode.DOWN_ERROR:
              case solace.SessionEventCode.CONNECT_FAILED_ERROR:
              case solace.SessionEventCode.DISCONNECTED:
              case solace.SessionEventCode.LOGIN_FAILURE:
                  if (myCW.desiredState !== 0) {
                      myCW._incrStat(ns.Statistics.SESSION_CONNECT_FAIL_COUNT);
                  }
                  // Should we reconnect?
                  if (myCW.desiredState !== 0 && reconnectStatus.attempt <= props.connectRetryCount) {
                      reconnectStatus.increment();
                      // launch reconnect
                      dispatchEvent(new AsyncIndication(ns.IndicationType.SESSION_DOWN_RETRYING, sessionevent.infoStr, null));
                      setTimeout(function () {
                          myCW._incrStat(ns.Statistics.SESSION_CONNECT_ATTEMPTS_COUNT);
                          rxsession.connect();
                      }, myCW.props.connectRetryInterval);
                  } else {
                      // Disconnected OK or failed permanently
                      dispatchEvent(new AsyncIndication(ns.IndicationType.SESSION_DOWN, sessionevent.infoStr, null));
                  }
                  break;
          }
      }

      function isRetryAllowed(reqWrapper) {
          return reqWrapper.isRetryAllowed(myCW.props.subscriptionRetryCount);
      }

      // Callback for message reception
      function solmsgcb(rxsession, msg) {
          // check discard-indication
          if (msg.isDiscardIndication()) {
              myCW._incrStat(ns.Statistics.DISCARD_INDICATION_COUNT);
              dispatchEvent(new AsyncIndication(ns.IndicationType.DISCARD_INDICATION, "Discard Indication", null));
          }

          // pass-through message indication to application
          myCW._incrStat(ns.Statistics.MESSAGES_RECEIVED_COUNT);
          dispatchEvent(new MessageIndication(msg));
      }

      // Callback for request/reply failure
      var onRequestFailure = function (solsession, failEv, userObj) {
          // pop the request from the work queue
          var reqWrapper = workQueue[userObj];
          if (reqWrapper) {
              var statFail = (reqWrapper.typeOptions.okEvent === ns.IndicationType.SUBSCRIPTION_OK) ?
                  ns.Statistics.SUBSCRIPTION_FAILED_COUNT : ns.Statistics.UNSUBSCRIBE_FAILED_COUNT;
              myCW._incrStat(statFail);
              logger.debug(strfmt("dbg>operationComplete FAIL: topic '{0}'",
                  reqWrapper.reqDict.SubscriptionTopic));

              delete workQueue[userObj];
              if (isRetryAllowed(reqWrapper)) {
                  scheduleOpRetry(reqWrapper);
              } else {
                  if (reqWrapper.typeOptions.source === SRC_USER) {
                      subscriptionCache.removeSubscription(reqWrapper);
                      dispatchEvent(new AsyncIndication(
                          reqWrapper.typeOptions.failEvent,
                          strfmt("Subscription failed ({0} attempts): {1}", reqWrapper.attempt, failEv.infoStr),
                          { correlationKey: reqWrapper.correlationKey }));
                  } else {
                      reconnectStatus.fail(reqWrapper);
                  }
              }
          }
      };

      // A subscription added OK will update our subn cache.
      function updateCacheOnOk(requestWrapper) {
          // Is this subscribe or unsubscribe?
          if (requestWrapper.typeOptions.okEvent === ns.IndicationType.SUBSCRIPTION_OK) {
              // add to cache
              subscriptionCache.processAddOk(requestWrapper);
          }
      }

      function mapResponseCode(code) {
          /*
           Maps a response code (200, 40x, 50x) from a service response to one of 3 cases:
           - OK (indicates success)
           - FAIL but retryable (all 500-series codes)
           - FAIL non-retryable (notify immediately user there was a failure, any other code)
           */
          if (code === 200)
              return ResponseCodes.OK_200;
          else if (code >= 500)
              return ResponseCodes.FAIL_RETRYABLE_50x;
          else
              return ResponseCodes.FAIL_TERMINAL_40x;
      }

      var onRegisterTask = function (task) {
          // Add a pending task to the work queue
          workQueue[task.uniqueId] = task;
      };

      /*
       Callback for request/reply returning a message.
       That message is examined for the response code, which is parsed into:
       * OK
       * Fail (retryable)
       * Fail (permanent)
       */
      var onRequestOk = function (solsession, replyMsg, userObj) {
          var reqWrapper = workQueue[userObj];
          if (reqWrapper) {
              delete workQueue[userObj];
              var extraFields = { correlationKey: reqWrapper.correlationKey };
              try {
                  var replyDict = new RequestFormatter().parseResponseMessage(replyMsg);
                  var parsedRespCode = mapResponseCode(replyDict.ResponseCode);

                  var noticeSubFailed = function () {
                      if (reqWrapper.typeOptions.source === SRC_USER) {
                          subscriptionCache.removeSubscription(reqWrapper);
                          dispatchEvent(new AsyncIndication(
                              reqWrapper.typeOptions.failEvent,
                              strfmt("Subscription failed ({0} attempts): {1}", reqWrapper.attempt, replyDict.ResponseString),
                              extraFields));
                      } else {
                          reconnectStatus.fail(reqWrapper);
                          solsession.disconnect();
                          dispatchEvent(new AsyncIndication(
                              ns.IndicationType.SESSION_DOWN,
                              "Terminal operation failure, no retries left: " + replyDict.ResponseString,
                              null));
                      }
                  };

                  var statFail = (reqWrapper.typeOptions.okEvent === ns.IndicationType.SUBSCRIPTION_OK) ?
                      ns.Statistics.SUBSCRIPTION_FAILED_COUNT : ns.Statistics.UNSUBSCRIBE_FAILED_COUNT;
                  logger.debug(strfmt("dbg>operationComplete: topic '{0}' code:{1}",
                      reqWrapper.reqDict.SubscriptionTopic,
                      parsedRespCode));

                  switch (parsedRespCode) {
                      case ResponseCodes.OK_200:
                          var statOk = (reqWrapper.typeOptions.okEvent === ns.IndicationType.SUBSCRIPTION_OK) ?
                              ns.Statistics.SUBSCRIPTION_OK_COUNT : ns.Statistics.UNSUBSCRIBE_OK_COUNT;
                          myCW._incrStat(statOk);
                          if (reqWrapper.typeOptions.source === SRC_USER) {
                              updateCacheOnOk(reqWrapper);
                              dispatchEvent(new AsyncIndication(
                                  reqWrapper.typeOptions.okEvent,
                                  "Subscription ok.",
                                  extraFields));
                          } else {
                              var allReapplyDone = reconnectStatus.ok(reqWrapper);
                              if (allReapplyDone) {
                                  dispatchEvent(new AsyncIndication(
                                      ns.IndicationType.SESSION_UP_WITH_SUBSCRIPTIONS,
                                      "All Subscriptions ok.", null));
                              }
                          }
                          break;
                      case ResponseCodes.FAIL_RETRYABLE_50x:
                          myCW._incrStat(statFail);
                          if (isRetryAllowed(reqWrapper))
                              scheduleOpRetry(reqWrapper);
                          else
                              noticeSubFailed();
                          break;
                      case ResponseCodes.FAIL_TERMINAL_40x:
                          myCW._incrStat(statFail);
                          noticeSubFailed();
                          break;
                  }

              } catch (err) {
                  myCW._incrStat(ns.Statistics.SUBSCRIPTION_FAILED_COUNT);
                  dispatchEvent(new AsyncIndication(
                      reqWrapper.typeOptions.failEvent,
                      "Subscription failed, invalid response message: " + err,
                      extraFields));
              }
          }
      };

      this._submitRequest = function (reqWrapper) {
          /// <summary>Attempt to submit or enqueue a request operation (if we're down).</summary>
          logger.debug(strfmt("dbg>submitRequest: submit request for '{0}'", reqWrapper.reqDict.SubscriptionTopic));
          var reqMessage = new RequestFormatter().asRequestMessage(reqWrapper);
          if (myCW.solSession && myCW.solSession.getSessionState() === solace.SessionState.CONNECTED) {
              myCW.solSession.sendRequest(reqMessage, this.props.subscriptionTimeout, onRequestOk, onRequestFailure, reqWrapper.uniqueId);
              onRegisterTask(reqWrapper);
          } else {
              // enqueue
              onRegisterTask(reqWrapper);
          }
      };

      function performRetry(reqWrapper) {
          logger.debug("performRetry: " + reqWrapper);
          reqWrapper.attempt = reqWrapper.attempt || 1;
          reqWrapper.attempt += 1;
          myCW._submitRequest(reqWrapper);
      }

      function scheduleOpRetry(reqWrapper) {
          var interval = myCW.props.subscriptionRetryInterval;
          logger.debug(strfmt("scheduleRetry: {0}ms, {1}", interval, reqWrapper));
          setTimeout(function () {
              performRetry(reqWrapper);
          }, interval);
      }

      // Initialize API session
      this.solSession = solace.SolclientFactory.createSession(
          this.props.solaceSessionProperties,
          new solace.MessageRxCBInfo(solmsgcb),
          new solace.SessionEventCBInfo(soleventcb));
  }
  ns.ClientWrapper = ClientWrapper; // bind to namespace


  ClientWrapper.prototype.connect = function () {
      /// <summary>
      /// Session connect: begins a connection attempt, an async event will indicate progress.
      /// </summary>
      this.desiredState = 1;
      this._incrStat(ns.Statistics.SESSION_CONNECT_ATTEMPTS_COUNT);
      this.solSession.connect();
  };

  ClientWrapper.prototype.disconnect = function () {
      /// <summary>
      /// Session disconnect: disconnects a session.
      /// </summary>
      this.desiredState = 0;
      this.solSession.disconnect();
  };

  ClientWrapper.prototype.dispose = function () {
      /// <summary>
      /// Session dispose: releases all underlying resources held by a ClientWrapper. This ClientWrapper is unusable after this call.
      /// </summary>
      this.solSession.dispose();
      this.solSession = null;
  };

  function mergeExtra(extra, target) {
      if (extra) {
          for (var ex_n in extra) {
              if (!(extra.hasOwnProperty(ex_n))) continue;
              target[ex_n] = extra[ex_n];
          }
      }
  }

  ClientWrapper.prototype.subscribe = function (opts) {
      /// <summary>
      /// Performs a service request to subscribe to a data flow. The opts parameter is a map satisfying:
      /// <para>{</para>
      /// <para>    serviceTopic: string representation of the topic on which to address the service request.</para>
      /// <para>    subscriptionTopic: string representation of the data topic to request.</para>
      /// <para>    correlationKey: object used for correlating async indications regarding this request.</para>
      /// <para>    serviceToken: a string representing the client's service auth token</para>
      /// <para>}</para>
      /// </summary>
      /// <param name="opts">Subscribe request options.</param>

      var ADDREQUEST = 1;
      var requestDict = {
          'OpCode': ADDREQUEST,
          'ClientName': this._getClientId(),
          'SubscriptionTopic': opts.subscriptionTopic,
          'SecurityToken': opts.serviceToken
      };
      // 'extra' is an object to merge into the request for debugging / testing purposes
      if (opts.extra) {
          mergeExtra(opts.extra, requestDict);
      }
      var req = new RequestWrapper(
          opts.serviceTopic,
          requestDict,
          opts.correlationKey,
          { okEvent: ns.IndicationType.SUBSCRIPTION_OK, failEvent: ns.IndicationType.SUBSCRIPTION_FAILED, source: SRC_USER });
      this.subscriptionCache.startAddSubscription(req);
      this._submitRequest(req);
  };

  ClientWrapper.prototype.unsubscribe = function (opts) {
      /// <summary>
      /// Performs a service request to unsubscribe from a data flow. The opts parameter is a map satisfying:
      /// <para>{</para>
      /// <para>    serviceTopic: string representation of the topic on which to address the service request.</para>
      /// <para>    subscriptionTopic: string representation of the data topic to request.</para>
      /// <para>    correlationKey: object used for correlating async indications regarding this request.</para>
      /// <para>    serviceToken: a string representing the client's service auth token</para>
      /// <para>}</para>
      /// </summary>
      /// <param name="opts">Subscribe request options.</param>

      var DELREQUEST = 2;
      var requestDict = {
          'OpCode': DELREQUEST,
          'ClientName': this._getClientId(),
          'SubscriptionTopic': opts.subscriptionTopic,
          'SecurityToken': opts.serviceToken
      };
      // 'extra' is an object to merge into the request for debugging / testing purposes
      if (opts.extra) {
          mergeExtra(opts.extra, requestDict);
      }
      var req = new RequestWrapper(
          opts.serviceTopic,
          requestDict,
          opts.correlationKey,
          { okEvent: ns.IndicationType.UNSUBSCRIBE_OK, failEvent: ns.IndicationType.UNSUBSCRIBE_FAILED, source: SRC_USER });
      this.subscriptionCache.removeSubscription(req);
      this._submitRequest(req);
  };

  ClientWrapper.prototype.getSessionProperties = function () {
      /// <summary>
      /// Gets the session properties for the currently active session.
      /// </summary>
      /// <returns type="solace.SessionProperties">Solace session properties.</returns>
      return this.solSession.getSessionProperties();
  };

  ClientWrapper.prototype.getStats = function () {
      /// <summary>
      /// Gets the wrapper statistics (see SolHB.Statistics).
      /// </summary>
      /// <returns type="object">A map of statistics indexed by SolHB.Statistics.*</returns>
      var ret = {};
      for (var s in this.stats) {
          if (!this.stats.hasOwnProperty(s)) continue;
          ret[s] = this.stats[s];
      }
      return ret;
  };

}(window.SolHB = window.SolHB || {}));


